import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CircularButton = ({ className = '', color, icon, onClick }) => {
  return (
    <button
      className={`circular-button circular-button-df ${className}`}
      type='button'
      onClick={onClick}
      style={{ color }}
    >
      <FontAwesomeIcon icon={icon} />
    </button>
  )
}

export default CircularButton
